import * as Yup from 'yup'

Yup.addMethod(Yup.string, 'validaHourTime', function(invalidMessage) {
  return this.test({
    name: 'is-valid-time',
    message: invalidMessage,
    test: function(value) {
      if (!value) return true

      const [hour, minute] = value.split(':')

      const validLength = val => val && val.length === 2

      const hourValid = validLength(hour) && hour < 24 && hour >= 0
      const minuteValid = validLength(minute) && minute < 60 && minute >= 0

      return hourValid && minuteValid
    }
  })
})

Yup.addMethod(Yup.string, 'timeGreaterThan', function(field, invalidMessage) {
  return this.test({
    name: 'is-greater',
    message: invalidMessage,
    test: function(value) {
      if (!value) return true

      return this.parent[field] < value
    }
  })
})
